import styled from "styled-components";
import { useProductContext } from "../context/productcontext"
import Product from "./Product";


const FeatureProducts = () => {

    const {isLoading,featureproducts}=useProductContext();
    // console.log("Feature Products:", featureproducts);  // only for testing purpose
    if(isLoading){
      return <div>......Loading</div>;
    }
  return (
   <Wrapper className="section">
     <div className="container">      
      <div className="common-heading">Our Favourite Product</div>
      <div className="product-intro">Check Now</div>
      <div className="grid grid-three-column">
        {
          featureproducts.map((curElem)=>{
            return <Product  key={curElem.SKU}{...curElem} />;
          })}
      </div>
     </div>

   </Wrapper>
  )
};
 


const Wrapper = styled.section`
  padding: 2rem 0;
  background-color: #e8f3ed;

  .container {
    max-width: 120rem;
    }  
 
  .grid-three-column {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    }

  .product-intro{
    font-size:1.2rem;
    margin-bottom: 1rem;
    }
  
  .common-heading {
    font-size: 3.2rem;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.colors.bgd};   
    
    }

  .card {
    background-color: #fff;
    border-radius: 1rem;
    border: 1px solid  #87b1b8;
    }
 
  figure {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    transition: all 0.5s linear;
    border-radius: 2rem;

   img {
    max-width: 90%;
    margin-top: 5rem;
    height: 18rem;
    transition: transform 0.2s linear;
    }       

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    width: 0%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: all 0.2s linear;
    }
  &:hover::after {
    width: 100%;
    }

  &:hover img {
    transform: scale(1.2);
    }
  }  

  .card-data {
    padding: 0 8%;
    
    }

  .card-data-flex {
    margin: 2rem 0;
    display: flex;
    gap: 0.5rem;
    justify-content: space-between;
    align-items: center;   
    }

 
   .card-data--price {
    font-weight: 400;
    color: rgb(14, 96, 249);
    }

   h3 {
    color: ${({ theme }) => theme.colors.text};
    text-transform: capitalize;
    }
  
  Button{
    display : none;
    }  
  
@media(max-width: ${({ theme }) => theme.media.mobile}) {
  padding: 2rem;

  .grid-three-column {
      grid-template-columns: repeat(2, 1fr);
      gap: 1.2rem;
      }

  figure {
      .caption {    
      top: 3%;
      text-align:center;
      padding: 0.3rem ;
      font-size: 1.5rem;
      }

    img {
      max-width: 100%;
      margin-top: 4rem;
      height: 10rem;
      }
    }
    .common-heading {
      font-size: 2.5rem;
      margin-bottom: 2.5rem;
      }

    .card {
      .card-data-flex {
      margin: 1rem;
      }
    
    .card-data {
      padding: 0;
      }

    h3 {
      font-size: 1.2rem;
      }

    p { 
      font-size: 1.4rem;
      }
    }

 
}
`;

export default FeatureProducts;

// const Wrapper=styled.section`
  
//padding:3rem;
//   background:#dfdfdf;

//   .container{    
//     display:flex;
//     flex-direction:column;

//     .product-intro{
//       font-size:15px;
//     }
//       .common-heading{
//       font-size:25px;
//     }
//   }
//     .figure{
//       width:10rem;
//       display:flex;
//       justify-content:center;
//       align-items:center;
//       position:relative;
//       overflow:hidden;
//       transition:all 0.5s linear;

//       &::after{
//         content:"";
//         position:absolute;
//         top:0;
//         left:0;
//         width:0%;
//         height:100%;
//         background-color:rgba(0,0,0,0.5);
//         transition:all 0.2s linear
//       }

//         &:hover::after {
//           width: 100%;
//         }
//         &:hover img {
//           transform: scale(1.2);
//         }
//         img {
//           max-width: 30%;
//           margin-top: 1.5rem;
//           height: 10rem;
//           transition: all 0.2s linear;
//         }

//         .caption {
//           position: absolute;
//           top: 15%;
//           right: 10%;
//           text-transform: uppercase;
//           background-color: ${({ theme }) => theme.colors.bg};
//           color: ${({ theme }) => theme.colors.helper};
//           padding: 0.8rem 2rem;
//           font-size: 1.2rem;
//           border-radius: 2rem;
//         }
//   }

//   .card {
//     background-color: #fff;
//     border-radius: 1rem;

//     .card-data {
//       padding: 0 2rem;
//     }

//     .card-data-flex {
//       margin: 2rem 0;
//       display: flex;
//       justify-content: space-between;
//       align-items: center;
//     }

//     h3 {
//       color: ${({ theme }) => theme.colors.text};
//       text-transform: capitalize;
//     }

//     .card-data--price {
//       color: ${({ theme }) => theme.colors.helper};
//     }

//     .btn {
//       margin: 2rem auto;
//       background-color: rgb(0 0 0 / 0%);
//       border: 0.1rem solid rgb(98 84 243);
//       display: flex;
//       justify-content: center;
//       align-items: center;

//       &:hover {
//         background-color: rgb(98 84 243);
//       }

//       &:hover a {
//         color: #fff;
//       }
//       a {
//         color: rgb(98 84 243);
//         font-size: 1.4rem;
//       }
//     }
//   }

// `;



// export default FeatureProducts;
